// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"aq-z","imageAndVideoCount":"bq-z","imageAndVideoContainer":"cq-z","viewAllReviews":"dq-z"};